import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { markAppointmentComplete } from '../../../services/api/cashless-vaccination';
import { toast } from 'react-toastify';

const VaccinationMarkCompleteModal = ({ isOpen, onClose, requestId, onComplete }) => {
    const handleSubmit = () => {
        if (!requestId) {
            return;
        }

        markAppointmentComplete(requestId)
            .then(() => {
                toast.success('Appointment marked as complete successfully');
                onComplete && onComplete();
                onClose();
            })
            .catch(() => {
                toast.error('Failed to mark appointment as complete');
            });
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>Mark Appointment Complete</ModalHeader>
            <ModalBody>
                Are you sure you want to mark this appointment as complete?
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleSubmit}>
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default VaccinationMarkCompleteModal;